import { render, staticRenderFns } from "./ButtonBackToPlayer.vue?vue&type=template&id=2880c771&scoped=true&"
import script from "./ButtonBackToPlayer.vue?vue&type=script&lang=js&"
export * from "./ButtonBackToPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBackToPlayer.vue?vue&type=style&index=0&id=2880c771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880c771",
  null
  
)

export default component.exports